import * as React from 'react';
import {
    Route, Switch,
} from 'react-router-dom';

import Home from './Home';
import Logout from './components/Logout';
import SelectRole from './components/SelectRole';

import urls from '../../app/urls';
import Login from './components/Login';
import ResetPassword from './components/ResetPassword';
import ForgotPassword from './components/ForgotPassword';
import RegisterUser from './components/RegisterUser';
import Layout from './components/Layout';
import Page from './Page';
import StudentLogin from './components/StudentLogin';
import LoadProfileData from '../../common/components/LoadProfileData';

const Pages = () => (
    <Layout>
        <Switch>
            <Route exact path={urls.register} component={RegisterUser} />
            <Route exact path={`${urls.logout}/:reason?`} component={Logout} />
            <Route exact path={`${urls.login}/${urls.loginParts.role}/:redirect?`} component={SelectRole} />
            <Route exact path={`${urls.login}/${urls.loginParts.accessCode}/:code/:state?`} component={Login} />
            <Route exact path={`${urls.login}/${urls.loginParts.resetPassword}/:token`} component={ResetPassword} />
            <Route exact path={`${urls.login}/${urls.loginParts.forgotPassword}`} component={ForgotPassword} />
            <Route exact path={`${urls.login}/${urls.loginParts.student}`} component={StudentLogin} />
            <Route exact path={`${urls.login}/:redirect?`} component={Login} />
            <Route path={`${urls.page}/:taskId`} component={Page} />
        </Switch>
    </Layout>
);

class Index extends React.Component {
    render() {
        return (
            <>
                <LoadProfileData />

                <Switch>
                    <Route exact path={urls.home} component={Home} />
                    <Route component={Pages} />
                </Switch>
            </>
        );
    }
}

export default Index;
